import { atom } from "recoil";

export type ErrorModalState = {
  id: string;
  isOpen: boolean;
  errorCode?: string;
  errorMessage?: string;
  errorData?: any;
  statusCode?: number;
  errorList?: string[];
  errorSubList?: string[];
  align?: "center" | "left";
  /** 원본 에러 객체 목록. Sentry 전송 로직이 이 참조로 메타를 읽고 중복 전송을 막는다. */
  causes: unknown[];
};

/**
 * API 에서 에러발생시 띄우는 에러 모달
 */
export const errorModalState = atom<ErrorModalState[]>({
  key: "errorModalState", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
